function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { IconBrands, IconColors, IconSizes, IconTypes } from './constants';
import { createSvgUrl, getIconBrand, iconAvailabilityKey, svgAttrUpdates, svgErrorHandler } from './utils';
import { StyledInlineSvg } from './styles';
import FallbackIcon from './FallbackIcon';
import LoadingPlaceholder from './LoadingPlaceholder';
import PropTypes from 'prop-types';
import React from 'react';
import { ThemingContext } from '../theming';
export var IconProps = {
  size: PropTypes.oneOf(Object.values(IconSizes)),
  color: PropTypes.oneOf(Object.values(IconColors))
};

var Icon = function Icon(_ref) {
  var color = _ref.color,
      size = _ref.size,
      type = _ref.type,
      accessibilityLabel = _ref.accessibilityLabel,
      useDefaultColors = _ref.useDefaultColors,
      accessibilityDescribedBy = _ref.accessibilityDescribedBy,
      shouldAdjustSmallSizesWhitespace = _ref.shouldAdjustSmallSizesWhitespace,
      props = _objectWithoutProperties(_ref, ["color", "size", "type", "accessibilityLabel", "useDefaultColors", "accessibilityDescribedBy", "shouldAdjustSmallSizesWhitespace"]);

  var theme = React.useContext(ThemingContext);
  var iconBrandToUse = getIconBrand(theme.Icons.Brand, type);

  if (!iconBrandToUse) {
    return /*#__PURE__*/React.createElement("div", null, "Unknown icon");
  }

  var iconKey = iconAvailabilityKey({
    brand: iconBrandToUse,
    size: size,
    type: type
  });
  var svgUrl = createSvgUrl(iconBrandToUse, iconKey);
  var iconColor = theme.Colors[color] || color;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      svgFetchError = _React$useState2[0],
      setSvgFetchError = _React$useState2[1]; // If there is an issue with fetching the icon SVG from the CDN or S3,
  // fallback to a "missing icon" icon to:
  // 1) ensure that there aren't a large number of blank spaces across project designs
  // 2) visually surface icon issue to developers


  if (svgFetchError) {
    return /*#__PURE__*/React.createElement(FallbackIcon, {
      "aria-describedby": accessibilityDescribedBy,
      "aria-hidden": accessibilityLabel === null || typeof accessibilityLabel !== 'string' || accessibilityLabel.length === 0,
      size: size,
      iconColor: iconColor,
      useDefaultColors: useDefaultColors
    });
  }

  return /*#__PURE__*/React.createElement(StyledInlineSvg // Note: the key is necessary to ensure the preProcessor function runs on every prop update
  // From https://github.com/gilbarbara/react-inlinesvg/issues/120
  , _extends({
    key: "".concat(size, "-").concat(type, "-").concat(color, "-").concat(useDefaultColors),
    loader: /*#__PURE__*/React.createElement(LoadingPlaceholder, {
      size: size
    }),
    onError: function onError(error) {
      return svgErrorHandler(error, setSvgFetchError);
    },
    preProcessor: function preProcessor(code) {
      return svgAttrUpdates({
        code: code,
        iconColor: iconColor,
        useDefaultColors: useDefaultColors
      });
    },
    title: accessibilityLabel,
    src: svgUrl,
    "aria-hidden": accessibilityLabel === null || typeof accessibilityLabel !== 'string' || accessibilityLabel.length === 0,
    "aria-describedby": accessibilityDescribedBy,
    width: size,
    height: size,
    $shouldAdjustBoundingWhitespace: // The visual quirk for bounding boxes & whitespace is only present for our 16 variant
    // icon assets, so we only need to apply this conditional CSS transformation when
    // a 16 variant icon asset is being fetched from S3
    iconKey.slice(0, 2) === '16' && (typeof shouldAdjustSmallSizesWhitespace !== 'undefined' ? shouldAdjustSmallSizesWhitespace : theme.Icons.shouldAdjustSmallSizesWhitespace)
  }, props));
};

Icon.propTypes = {
  type: PropTypes.oneOf(Object.keys(IconTypes)).isRequired,
  size: PropTypes.oneOfType([PropTypes.oneOf(Object.values(IconSizes)), PropTypes.number]),
  color: PropTypes.oneOf(Object.values(IconColors)),
  useDefaultColors: PropTypes.bool,
  accessibilityLabel: PropTypes.string,
  accessibilityDescribedBy: PropTypes.string,
  shouldAdjustSmallSizesWhitespace: PropTypes.bool
};
Icon.defaultProps = {
  type: IconTypes.StarFill,
  size: IconSizes.Medium,
  color: IconColors.SystemBlack,
  useDefaultColors: false,
  accessibilityLabel: ''
};
Icon.Brands = IconBrands;
Icon.Sizes = IconSizes;
Icon.Colors = IconColors;
Icon.Types = IconTypes;
export default Icon;